<div
    [class]="'ap-notification ap-notification--' + status()"
    [ngClass]="{
        'ap-notification--last': last()
    }"
>
    <div class="ap-notification__container word-break">
        @if (showIcon()) {
            <div class="ap-notification__icon" aria-hidden="true">
                <asn-icon [manualSize]="20" [name]="getIconName()" data-testid="icon"></asn-icon>
            </div>
        }
        <div
            class="ap-notification__content-container"
            data-testid="content"
            [class.ap-notification__content-container--no-padding-right]="closeable()"
        >
            <ng-content></ng-content>
        </div>
        @if (closeable()) {
            <div class="ap-notification__close-action">
                <div class="ap-notification__close-action--hover-container">
                    <button (click)="emitClosed()" ariaLabel="Sluiten" class="close" data-testid="close-button">
                        <asn-icon name="close"></asn-icon>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
